/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-05-25 16:14:00
 *
 *******************************************************/
 import createApp from '@shopify/app-bridge';

 import { app } from 'src/config';

 let host = null;

 let SABAppInstance_Normal = null;
 let SABAppInstance_NoForceRedirect = null;

 export function saveHost(value) {
   host = value;
 }

 function createInstances() {
   const normalConfig = {
     apiKey: app.apiKey,
     host,
     forceRedirect: process.env.NODE_ENV !== 'development'
   };
   const configNoForceRedirect = {
     ...normalConfig,
     forceRedirect: false
   };

   SABAppInstance_Normal = createApp(normalConfig);
   SABAppInstance_NoForceRedirect = createApp(configNoForceRedirect);
 }

 export function getSABAppInstance_Normal() {
   if (!SABAppInstance_Normal) createInstances();
   return SABAppInstance_Normal;
 }

 export function getSABAppInstance_NoForceRedirect() {
   if (!SABAppInstance_NoForceRedirect) createInstances();
   return SABAppInstance_NoForceRedirect;
 }
